import { ModalWidth, ROW_GUTTER, VALIDATE_REQUIRED } from '@/config';
import { RegisterBalanceType } from '@/constants';
import { defaultApiErrorHandle } from '@/helpers/errorHandler';
import { formatCurrency } from '@/helpers/format';
import { apiSdk } from '@/httpClient';
import { Col, Form, Input, InputNumber, Modal, Row, Select, Spin } from 'antd';
import FormItem from 'antd/es/form/FormItem';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  onClose: (reload: boolean) => void;
  registerId: string;
};

export default function RechargeAndWithdrawModal({ onClose, registerId }: Props) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [loading, setIsLoading] = React.useState<boolean>(false);
  const [currentBalance, setCurrentBalance] = React.useState<number>();

  const onSubmit = (values: any) => {
    setIsLoading(true);
    apiSdk.RegisterService.updateCurrentBalance({ body: { ...values, registerId: registerId } })
      .then(res => {
        onClose(true);
      })
      .catch(defaultApiErrorHandle)
      .finally(() => {
        setIsLoading(false);
      });
  };
  const type = Form.useWatch('type', form);
  React.useEffect(() => {
    if (type) {
      setIsLoading(true);
      apiSdk.RegisterService.getCurrentBalance({ registerId: registerId, type: type })
        .then(res => {
          setCurrentBalance(res);
        })
        .catch(defaultApiErrorHandle)
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [type]);

  return (
    <Modal
      style={{ top: 10 }}
      open={true}
      maskClosable={false}
      width={ModalWidth.small}
      className="nta-custom-form"
      title={t('registerPage_RechargeWithdraw')}
      forceRender={true}
      okText={t('registerPage_ProcessAction')}
      okButtonProps={{ className: 'save-btn' }}
      cancelText={t('base.Close')}
      onCancel={() => {
        onClose(false);
      }}
      onOk={() => {
        form
          .validateFields()
          .then(values => {
            onSubmit(values);
          })
          .catch(info => {});
      }}
    >
      <Form
        initialValues={{ type: RegisterBalanceType.Deposit }}
        form={form}
        size="middle"
        layout="horizontal"
        labelAlign="right"
        labelCol={{ md: 10 }}
      >
        <Spin spinning={loading}>
          <Row gutter={ROW_GUTTER}>
            <Col md={24}>
              <FormItem label={t('registerPage_SelectAction')} name="type" rules={[{ required: true, message: VALIDATE_REQUIRED }]}>
                <Select options={RegisterBalanceType.__getSelectOptions()} />
              </FormItem>

              <FormItem label={t('registerPage_CurrentBalance')}>
                <Input disabled value={formatCurrency(currentBalance)} className="input-value-color" />
              </FormItem>
              <FormItem label={t('registerPage_AmountToTransfer')} name="amount" rules={[{ required: true, message: VALIDATE_REQUIRED }]}>
                <InputNumber min={0} formatter={x => formatCurrency(x)} className="w-100" />
              </FormItem>
            </Col>
          </Row>
        </Spin>
      </Form>
    </Modal>
  );
}
